import { Typography } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

function ErrorPage() {
  return (
    <div className="error-page">
      <SentimentVeryDissatisfiedIcon sx={{ color: "white", fontSize: 100, marginTop: "200px" }} />
      <Typography sx={{ textAlign: "center", marginTop: "20px", color: "white" }} variant="h2">
        Page not found!
      </Typography>
      <Typography sx={{ textAlign: "center", marginTop: "30px", color: "white" }} variant="h5">
        Contact tournament organizer for more information.
      </Typography>
    </div>
  );
}

export default ErrorPage;
